import { Component, OnInit } from '@angular/core';
import { AnouncementService } from '../../services/anouncement.service';
import { AnouncementItem } from '../../models/anouncementItem';
import { IList } from '../../../core/interface/IList';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../environments/environment';
import { OrderCountCubeService } from '../../services/orderCountCube.service';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    todayOrder = 0;
    notConfirmOrder = 0;
    notReplyOrder = 0;
    notReplyBatchOrder = 0;
    exceptedTodayOrder = 0;
    exceptedTodayBatchOrder = 0;
    overDueOrder = 0;
    onPassageOrder = 0;

    anoData$: Observable<IList<AnouncementItem>>;
    get hasInquiry() {
        return environment.inquiry;
    }

    todayOrderRoute() {
        const today = moment(new Date()).format('YYYY/MM/DD');
        this.router.navigate(['/order/list'], {
            queryParams: {
                'datetimeS': today,
                'datetimeE': today,
                'date': new Date().getTime()
            }
        });
    }
    notConfirmOrderRoute() {
        this.router.navigate(['/order/list'], {
            queryParams: { 'stateValue': 0, 'date': new Date().getTime() }
        });
    }
    notReplyOrderRoute() {
        if (this.notReplyOrder || !this.notReplyBatchOrder) {
            this.router.navigate(['/order/reply-delivery'], {
                queryParams: { 'replyStatus': 0, 'date': new Date().getTime() }
            });
        } else {
            this.router.navigate(['/order/batch-reply-delivery'], {
                queryParams: { 'replyStatus': 0, 'date': new Date().getTime() }
            });
        }
    }
    exceptedTodayOrderRoute() {
        const today = moment(new Date()).format('YYYY/MM/DD');
        if (this.exceptedTodayOrder || !this.exceptedTodayBatchOrder) {
            this.router.navigate(['/order/reply-delivery'], {
                queryParams: {
                    'replyDateS': today,
                    'replyDateE': today,
                    'date': new Date().getTime()
                }
            });
        } else {
            this.router.navigate(['/order/batch-reply-delivery'], {
                queryParams: {
                    'replyDateBatchS': today,
                    'replyDateBatchE': today,
                    'date': new Date().getTime()
                }
            });
        }
    }
    overDueOrderRoute() {
        this.router.navigate(['/order/list'], {
            queryParams: { 'overDue': 'Y', 'date': new Date().getTime() }
        });
    }
    onPassageOrderRoute() {
        this.router.navigate(['/delivery/list'], {
            queryParams: { 'status': 2, 'date': new Date().getTime() }
        });
    }

    constructor(
        private service: AnouncementService,
        private orderCountCubeService: OrderCountCubeService,
        private router: Router
    ) { }

    ngOnInit() {
        this.anoData$ = this.service.getAnoucements(0, 5);
        this.orderCountCubeService.getOrderCount().subscribe(data => {
            this.todayOrder = data.purchaseNum;
            this.notConfirmOrder = data.unConfirmNum;
            this.notReplyOrder = data.unReplyNum;
            this.notReplyBatchOrder = data.unReplyBatchNum;
            this.exceptedTodayOrder = data.expectDeliveryNum;
            this.exceptedTodayBatchOrder = data.expectDeliveryBatchNum;
            this.overDueOrder = data.overDueNum;
            this.onPassageOrder = data.onTheWayNum;
        });
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/home/home.component.ts